<template>
    <div class="bg-white p-6 shadow-md">
        <h2 class="text-xl font-semibold text-gray-800 mb-4 flex items-center">
            <span class="mr-2">🌴🌳</span>
            <span>Palm vs Trees Distribution</span>
        </h2>
        <apexchart class="flex justify-center items-center" type="pie" width="350" :options="chartOptions"
            :series="series"></apexchart>
    </div>
</template>

<script>
export default {
    name: "PalmAndTreesByCount",
    props: ["data"],
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    type: 'pie'
                },
                labels: ["Trees", "Palm"],
                legend: {
                    position: 'bottom',
                    formatter: function (val, opts) {
                        return val + " - " + opts.w.globals.series[opts.seriesIndex]
                    }
                },
                dataLabels: {
                    enabled: true,
                },
                colors: ["#2A9D8F", "#E9C46A"]
            }
        };
    },
    watch: {
        data: {
            handler(newData) {

                if (!Array.isArray(newData)) return;

                let totalTrees = 0;
                let totalPalm = 0;

                newData.forEach(item => {
                    item.plants.forEach(plant => {
                        if (plant.type === "Trees") {
                            totalTrees += plant.total;
                        } else if (plant.type === "Palm") {
                            totalPalm += plant.total;
                        }
                    });
                });

                this.series = [totalTrees, totalPalm];
            },
            immediate: true,
            deep: true,
        },
    },
}
</script>